class CustomScriptData {
    constructor(title = "", code = "") {
        this.title = title;
        this.code = code;
    }
}

export default CustomScriptData;